import React from "react";
import PropTypes from "prop-types";

import videoIcon from "../assets/video.png";
import checkmark from "../assets/checkmark.png";
import location from "../assets/location.png";
import warning from "../assets/warning.png";
import alert from "../assets/alert.png";
import eye from "../assets/eye.png";
import iphone from "../assets/iphone.png";

const titleToImageMap = {
  "trip started": checkmark,
  "location update": location,
  "idle detected": alert,
  "battery low": iphone,
  "lost on radar": eye,
  "seen on radar": checkmark,
  "wellbeing check triggered(virtual travel guard)": warning,
  "wellbeing check triggered(virtual travel check)": warning,
  "wellbeing check triggered(virtual home check)": warning,
  "escort ended": checkmark,
  "escort interrupted": videoIcon,
};

const getImageForTitle = (title = "") => {
  const lowerTitle = title.toLowerCase().trim();
  const matchKey = Object.keys(titleToImageMap).find((key) =>
    lowerTitle.includes(key.toLowerCase())
  );
  return matchKey ? titleToImageMap[matchKey] : titleToImageMap.default;
};

function NotificationImage({ title, width = 40, height = 40, style = {} }) {
  const imageSrc = getImageForTitle(title);

  return (
    <img
      src={imageSrc}
      alt={title}
      width={width}
      height={height}
      style={{ objectFit: "contain", ...style }}
    />
  );
}

NotificationImage.propTypes = {
  title: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
};

export default NotificationImage;
